import { render, staticRenderFns } from "./invitationClientManage.vue?vue&type=template&id=4f707a08"
import script from "./invitationClientManage.vue?vue&type=script&lang=js"
export * from "./invitationClientManage.vue?vue&type=script&lang=js"
import style0 from "./invitationClientManage.vue?vue&type=style&index=0&id=4f707a08&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports